// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"7f230583","372":"362df0f2","388":"4506bab1","622":"1635db8d","745":"dda26590","748":"47aef446","787":"3484f3b1","798":"2e2a6d9b","897":"04543505"}[chunkId] + ".chunk.js";
};